module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@4.25.0_gatsby@4.25.9_@types+webpack@4.41.40_babel-eslint@10.1.0__6186b0530ac142eebefbb8be64a4129d/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Adshim","short_name":"Adshim","start_url":"/","icon":"./src/assets/images/adshim.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"746065e3caea211869e98427aebd48e8"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@4.25.9_@types+webpack@4.41.40_babel-eslint@10.1.0_eslint@7.32.0_supports-color@8_1c92e7123984bb8bd916ae6e377c6f9d/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
